export default {
  relics: 'Relics',
  museum: 'Museum',

  torch: 'Torch',
  purpleHeart: 'Purple heart',
  rottenLeaf: 'Rotten leaf',
  stonepiercer: 'Stonepiercer',
  consolationPrize: 'Consolation prize',
  prettyLamp: 'Pretty lamp',
  chessboard: 'Chess board',
  iridiscentFlower: 'Iridiscent flower',
  excavator: 'Excavator',
  redCard: 'Red card',
  briefcase: 'Briefcase',
  strangePlant: 'Strange plant',
  beneficialVirus: 'Beneficial virus',
  friendlyBat: 'Friendly bat',
  hammer: 'Hammer',
  aluminiumBrick: 'Aluminium brick',
  copperBrick: 'Copper brick',
  aluminiumHeap: 'Aluminium heap',
  bomb: 'Bomb',
  copperHeap: 'Copper heap',
  radar: 'Radar',
  press: 'Press',
  cupboard: 'Cupboard',
  catalyst: 'Catalyst',
  jumprope: 'Jumprope',
  bronzePickaxe: 'Bronze pickaxe',
  oreShelf: 'Ore shelf',
  coalBrick: 'Coal brick',
  washingMachine: 'Washing machine',
  magnet: 'Magnet',
  copperPickaxe: 'Copper pickaxe',
  tinBucket: 'Tin bucket',
  honeyPot: 'Pot of honey',
  openedGift: 'Opened gift',
  mudBrick: 'Mud brick',
  sapling: 'Sapling',
  keychain: 'Keychain',
  treasureChest: 'Treasure chest',
  screwdriver: 'Screwdriver',
  rose: 'Rose',
  goldenKey: 'Golden key',
  supervisor: 'Supervisor',
  globe: 'Globe',
  forgottenShield: 'Forgotten shield',
  burningSkull: 'Burning skull',
  dumbbell: 'Dumbbell',
  energyDrink: 'Energy drink',
  luckyDice: 'Lucky dice',
  newBackpack: 'New backpack',
  crackedSafe: 'Cracked safe',
  ultimateGuide: 'Ultimate guide',
  bandage: 'Bandage',
  goldenCarrot: 'Golden carrot',
  goldenApple: 'Golden apple',
  popcorn: 'Popcorn',
  roseQuartz: 'Rose quartz',
  goldenSeed: 'Golden seed',
  trellis: 'Trellis',
  brickWall: 'Brick wall',
  printer: 'Printer',
  lightbulb: 'Lightbulb',
  oldTV: 'Old TV',
  worryingMail: 'Worrying mail',
  redBalloon: 'Red balloon',
  sackOfGold: 'Sack of gold',
  shredder: 'Shredder',
  redprint: 'Redprint',
  orangeBalloon: 'Orange balloon',
  creditCard: 'Credit card',
  simpleCalculator: 'Simple calculator',
  orangeprint: 'Orangeprint',
  yellowBalloon: 'Yellow balloon',
  fishbowl: 'Fishbowl',
  pencil: 'Pencil',
  smallBrush: 'Small brush',
  strangePills: 'Strange pills',
  strangeScroll: 'Strange scroll',
  printingPress: 'Printing press',
  yellowprint: 'Yellowprint',
  greenBalloon: 'Green balloon',
  woodenHanger: 'Wooden hanger',
  bedsheet: 'Bedsheet',
  imageAlbum: 'Image album',
  greenprint: 'Greenprint',
  blueBalloon: 'Blue balloon',
  blueprint: 'Blueprint',
  purpleBalloon: 'Purple balloon',
  tinfoilHat: 'Tinfoil hat',
  cupOfWater: 'Cup of water',
  combatStrategy: 'Combat strategy',
  hundredDollarBill: '100-Dollar bill',
  hotAirBalloon: 'Hot air balloon',
  largeClover: 'Large clover',
  eightBall: '8-ball',
  youngPig: 'Young pig',
  silverHorseshoe: 'Silver horseshoe',
  bronzeTools: 'Bronze tools',
  minersHat: 'Miners hat',
  dictionary: 'Dictionary',
  expertTools: 'Expert tools',
  bloodBag: 'Blood bag',
  geode: 'Geode',
  birthdayCake: 'Birthday cake',
  colorfulFlower: 'Colorful flower',
  heatingBulb: 'Heating bulb',
  trashCan: 'Trash can',
  suitcase: 'Suitcase',
  fakeSuitcase: 'Fake Suitcase',
  tropicalTent: 'Tropical tent',
  fruitBasket: 'Fruit basket',
  massiveGrain: 'Massive grain',
  enchantedBottle: 'Enchanted bottle',
  moneyGift: 'Money gift',
  frozenCarrot: 'Frozen carrot',
};
